import { TimeRange } from "@/types/enums";

export interface MonthOption {
  value: string;
  label: string;
}

/**
 * Month options for dropdowns and selectors
 * Uses 0-based month indexing (0 = January, 11 = December)
 */
export const MONTH_OPTIONS: MonthOption[] = [
  { value: TimeRange.ALL, label: 'All Months' },
  { value: '0', label: 'January' },
  { value: '1', label: 'February' },
  { value: '2', label: 'March' },
  { value: '3', label: 'April' },
  { value: '4', label: 'May' },
  { value: '5', label: 'June' },
  { value: '6', label: 'July' },
  { value: '7', label: 'August' },
  { value: '8', label: 'September' },
  { value: '9', label: 'October' },
  { value: '10', label: 'November' },
  { value: '11', label: 'December' }
];

/**
 * Get month name by index (0-based)
 */
export const getMonthName = (monthIndex: number): string => {
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  return monthNames[monthIndex] || 'Unknown';
};

/**
 * Get month abbreviation by index (0-based)
 */
export const getMonthAbbreviation = (monthIndex: number): string => {
  const monthAbbreviations = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  return monthAbbreviations[monthIndex] || 'Unknown';
};

/**
 * Get month index by name (case-insensitive)
 */
export const getMonthIndex = (monthName: string): number => {
  const normalizedName = monthName.toLowerCase().trim();
  const monthNames = [
    'january', 'february', 'march', 'april', 'may', 'june',
    'july', 'august', 'september', 'october', 'november', 'december'
  ];
  return monthNames.indexOf(normalizedName);
};
